<template>
  <div class="login">
    <header>
      <div class="login__header-line"></div>
      <h2 class="login__title">帳號登入</h2>
    </header>
    <b-form @submit="onSubmit">
      <b-form-input
        class="login__input"
        v-model="form.teamCode"
        type="text"
        placeholder="車隊編號"
        required
      ></b-form-input>

      <b-form-input
        class="login__input"
        v-model="form.account"
        type="text"
        placeholder="使用者帳號"
        required
      ></b-form-input>

      <b-form-input
        class="login__input"
        v-model="form.password"
        type="password"
        placeholder="使用者密碼"
        required
      ></b-form-input>

      <b-button
        class="login__button"
        type="submit"
        @click.prevent="onSubmit"
        ref="modalShow"
        >登入
      </b-button>
    </b-form>
    <footer>
      <hr class="login__footer-line" />
      <h1 class="login__title">GLAD Taxi 享受生活</h1>
      <p class="login__copyright">©2021 資通行動科技有限公司v2.0.0</p>
    </footer>
  </div>
</template>

<script>
import Cookie from 'js-cookie';
import { mapActions } from 'vuex';
import { errorMessageParse } from '@/utils/errorMessage';

export default {
  name: 'Login',
  components: {
    // ErrorModal
  },
  data() {
    return {
      form: {
        teamCode: '',
        account: '',
        password: ''
      }
    };
  },
  methods: {
    ...mapActions({
      login: 'login'
    }),
    async onSubmit() {
      try {
        const { result } = await this.login({
          account: this.form.account,
          password: this.form.password,
          teamCode: this.form.teamCode
        });
        Cookie.set('token', result.token);
        Cookie.set(
          'user',
          `${result.managerName}（${result.positionInfo.positionName}）`
        );
        this.$router.push({ name: 'Home' });
      } catch (err) {
        console.warn('err', err);
        this.$store.commit('errorMessage', errorMessageParse(err));
        this.$root.$emit('bv::show::modal', 'error-modal');
      }
      // try {
      //   const res = await this.login({
      //     account: this.form.account,
      //     password: this.form.password,
      //     team_code: this.form.teamCode
      //   });
      //   Cookie.set('token', res.token);
      //   Cookie.set(
      //     'user',
      //     `${res.managerName}（${res.positionInfo.positionName}）`
      //   );
      //   this.$router.push({ name: 'Home' });
      // } catch (err) {
      //   console.warn('err', err);
      //   this.$store.commit('errorMessage', errorMessageParse(err));
      //   this.$root.$emit('bv::show::modal', 'error-modal');
      // }
    },
    onReset(event) {
      event.preventDefault();
      // Reset our form values
      this.form.teamcode = '';
      this.form.managerAccount = '';
      this.form.password = '';
    },
    beforRouteLeave(_to, _from, next) {
      next();
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  text-align: center;
  width: 350px;
  margin: 5% auto 0 auto;

  &__header-line {
    margin-top: 10px;
    height: 15px;
    position: relative;

    &::before {
      content: '';
      background: linear-gradient(270deg, #7e7e7e 0, #fff);
      width: 20%;
      height: 1px;
      position: absolute;
      top: 0;
      left: 0;
    }
    &::after {
      content: '';
      background: linear-gradient(90deg, #7e7e7e 0, #fff);
      width: 20%;
      height: 1px;
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  &__title {
    color: #73879c;
    font-size: 25px;
    // font-family: Helvetica, Arial, sans-serif;
    font-weight: 400;
    margin-bottom: 30px;
  }

  &__input {
    height: 34px;
    width: 100%;
    padding: 6px 12px;
    font-size: 14px;
    background-color: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 1px 0 #fff, inset 0 -2px 5px rgb(0 0 0 / 8%);
    border: 1px solid #c8c8c8;
    color: #777;
  }

  &__button {
    border-radius: 3px;
    color: #333;
    cursor: pointer;
    border: 1px solid #ccc;
    padding: 6px 12px;
    font-size: 14px;
    margin: 0;
    background-color: #efefef;
  }

  &__footer-line {
    margin-top: 35px;
    padding-top: 30px;
    border-top: 1px solid #d8d8d8;
  }

  &__copyright {
    margin: 0 0 10px;
    font-size: 13px;
    color: #73879c;
  }
}
</style>
